<template>
  <div class="accessories" id="accessories">
    <div class="accessories-left">
      <object ref="drawing" class="accessories-drawing" type="image/svg+xml" data="accessories-drawing.svg?r=1" width="250.3707733" height="383.4519958"></object>
    </div>
    <div class="accessories-body">
      <table class="accessories-table">
        <thead>
          <th>Комплектующие</th>
          <th>т/шт</th>
          <th>Кол-во</th>
          <th>Стоимость/т</th>
        </thead>
        <tbody>
          <tr v-for="(item, i) in items" :key="i" @mouseenter="setDrawingDisplay(item.type, 'block', item)" @mouseleave="setDrawingDisplay(item.type, 'none', item)">
            <td><span class="accessories-pseudo">{{ item.name }}</span></td>
            <td>{{ item.price }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ (item.price * item.quantity).toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="accessories-summary">
        Сумма: {{ price }} т
      </div>
      <Checkbox :value="wedgeAnchors" @input="$emit('update:wedgeAnchors', $event)">Добавить клиновые Анкера</Checkbox>
    </div>
    <div class="accessories-right">
      <div class="accessories-priceLabel">Итого:</div>
      <div class="accessories-price">{{ price }} т</div>
      <div class="accessories-icons">
        <a href="#" class="accessories-icon_print" @click.prevent="$emit('print')" title="Печать"></a>
        <a href="#" class="accessories-icon_download" @click.prevent="$emit('download')" title="Скачать"></a>
        <a href="#modal-calc-email" class="accessories-icon_mail" data-fancybox title="Отправить на почту"></a>
        <a href="#modal-calc-dealer" class="accessories-icon_dealer" data-fancybox title="Выписать счет для дилера"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkbox from './Checkbox';

  export default {
    props: {
      items: Array,
      wedgeAnchors: Boolean,
    },
    computed: {
      price() {
        return this.items.reduce((a, c) => a + c.price * c.quantity, 0).toFixed(2);
      },
      hasGridShelves() {
        const shelfTypes = [];
        this.items.forEach(item => {
          if (item.type === 'tier_shelf') {
            shelfTypes.push(item.shelvesType)
          }
        });

        return shelfTypes.includes('Сетчатые');
      },
      hasSolidShelves() {
        const shelfTypes = [];
        this.items.forEach(item => {
          if (item.type === 'tier_shelf') {
            shelfTypes.push(item.shelvesType)
          }
        });

        return shelfTypes.includes('Стандартные');
      },
      hasSideScreens() {
        let has = false
        this.items.forEach(item => {
          if (item.type === 'side_screen') {
            has = true
          }
        });

        return has
      },
      hasBackScreens() {
        let has = false
        this.items.forEach(item => {
          if (item.type === 'back_screen') {
            has = true
          }
        });

        return has
      }
    },
    mounted() {
      // mounted() does not guarantee that the DOM has finished rendering. 
      // wait for this.$nextTick()
      this.$nextTick(() => {
        if (this.$refs.drawing && this.$refs.drawing.getSVGDocument()) {
          this.updateDrawingShelvesDisplay()
          this.updateDrawingScreensDisplay()
        }
        else
          setTimeout(() => {
            if (this.$refs.drawing && this.$refs.drawing.getSVGDocument()) {
              this.updateDrawingShelvesDisplay()
              this.updateDrawingScreensDisplay()
            }
          }, 100)
      });
    },
    updated() {
      setTimeout(() => {
        this.updateDrawingShelvesDisplay()
        this.updateDrawingScreensDisplay()
      }, 100)
    },
    methods: {
      getDrawingElement(id) {
        const el = this.$refs.drawing.getSVGDocument()
        return el ? el.getElementById(id) : false;
      },
      setDrawingDisplay(id, display, item) {
        if (id === 'tier_shelf') {
          this.setDrawingDisplayTierShelf(display, item)
        } else if (id === 'beam_coupler') {
          this.setDrawingDisplay('screeds', display, item)
        } else if (id === 'back_screen') {
          this.setDrawingDisplay('back_screen_color', display, item)
        } else if (id === 'side_screen') {
          this.setDrawingDisplay('screen_left_color', display, item)
          this.setDrawingDisplay('screen_right_color', display, item)
        } else {
          const el = this.getDrawingElement(id);
          if (el) {
            el.style.display = display;
          }
        }
      },
      setDrawingDisplayTierShelf(display, item) {
          const tier_shelf = this.getDrawingElement('tier_shelf');
          const tier_shelf_2 = this.getDrawingElement('tier_shelf_2');
          if (display === 'block') {
            if (this.hasGridShelves && !this.hasSolidShelves) { // display only grid
              for (let i = 1; i <= 5; i++) {
                const gridColored = this.getDrawingElement(`grid_shelve_colored_${i}`);
                gridColored.style.display = 'block'
              }
            } else if (this.hasGridShelves && this.hasSolidShelves) { // display both
              if (item.shelvesType === 'Стандартные') {
                tier_shelf_2.style.display = 'block'
              }
              if (item.shelvesType === 'Сетчатые') {
                const gridColored = this.getDrawingElement('grid_shelve_colored_1');
                gridColored.style.display = 'block'
              }
            } else { // display only solid
              const gridColored = this.getDrawingElement('grid_shelve_colored_1');
              tier_shelf.style.display = 'block'
            }
          } else {
            tier_shelf.style.display = 'none'
            tier_shelf_2.style.display = 'none'
            for (let i = 1; i <= 5; i++) {
              const gridColored = this.getDrawingElement(`grid_shelve_colored_${i}`);
              gridColored.style.display = 'none'
            }
          }
      },
      updateDrawingScreensDisplay() {
        const screen_left = this.getDrawingElement(`screen_left_1_`);
        const screen_right = this.getDrawingElement(`screen_right_1_`);
        const back_screen = this.getDrawingElement(`back_screen`);
        screen_left.style.display = this.hasSideScreens ? 'block' : 'none';
        screen_right.style.display = this.hasSideScreens ? 'block' : 'none';
        back_screen.style.display = this.hasBackScreens ? 'block' : 'none';
      },
      updateDrawingShelvesDisplay() {
        if (this.hasGridShelves && !this.hasSolidShelves) { // display only grid
          for (let i = 1; i <= 5; i++) {
            const reflect = this.getDrawingElement(`reflect_${i}_1_`);
            const solid = this.getDrawingElement(`solid_shelve_${i}`);
            const shadow = this.getDrawingElement(`shadow_${i}`);
            const grid = this.getDrawingElement(`grid_shelve_${i}`);
            if (reflect) reflect.style.display = 'none'
            if (solid) solid.style.display = 'none'
            if (shadow) shadow.style.display = 'none'
            if (grid) grid.style.display = 'block'
          }
        } else if (this.hasGridShelves && this.hasSolidShelves) { // display both
          for (let i = 1; i <= 5; i++) {
            const reflect = this.getDrawingElement(`reflect_${i}_1_`);
            const solid = this.getDrawingElement(`solid_shelve_${i}`);
            const shadow = this.getDrawingElement(`shadow_${i}`);
            const grid = this.getDrawingElement(`grid_shelve_${i}`);
            if (i === 1) {
              if (reflect) reflect.style.display = 'none'
              if (solid) solid.style.display = 'none'
              if (shadow) shadow.style.display = 'none'
              if (grid) grid.style.display = 'block'
            } else {
              if (reflect) reflect.style.display = 'block'
              if (solid) solid.style.display = 'block'
              if (shadow) shadow.style.display = 'block'
              if (grid) grid.style.display = 'none'
            }
          }
        } else { // display only solid
          for (let i = 1; i <= 5; i++) {
            const reflect = this.getDrawingElement(`reflect_${i}_1_`);
            const solid = this.getDrawingElement(`solid_shelve_${i}`);
            const shadow = this.getDrawingElement(`shadow_${i}`);
            const grid = this.getDrawingElement(`grid_shelve_${i}`);
            if (reflect) reflect.style.display = 'block'
            if (solid) solid.style.display = 'block'
            if (shadow) shadow.style.display = 'block'
            if (grid) grid.style.display = 'none'
          }
        }
      }
    },
    components: {
      Checkbox,
    },
  }
</script>

<style scoped>
  .accessories {
    display: flex;
    margin-top: 50px;
  }
  .accessories-left {
    width: 392px;
  }
  .accessories-body {
    flex: 1;
    margin-top: 20px;
  }
  .accessories-right {
    margin-top: 20px;
    margin-left: 30px;
    width: 226px;
  }
  .accessories-drawing {
    margin-left: 50px;
  }
  .accessories-table {
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
  }
  .accessories-table th {
    padding: 14px;
    white-space: nowrap;
    text-align: left;
    font-weight: normal;
    background: #F6F6F6;
  }
  .accessories-table td {
    padding: 8px 14px;
  }
  .accessories-table tr:nth-child(2n) td {
    background: #F6F6F6;
  }
  .accessories-table tr:hover {
    color: #0B53B3;
    cursor: pointer;
  }
  .accessories-pseudo {
    font-weight: bold;
    border-bottom: 1px dashed #333333;
  }
  .accessories-summary {
    margin: 16px 0;
    padding: 16px 14px;
    background: #F6F6F6;
  }
  .accessories-priceLabel {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
  }
  .accessories-price {
    margin-bottom: 46px;
    font-weight: bold;
    font-size: 30px;
  }
  .accessories-icons {
    margin-left: -6px;
  }
  .accessories-icon_print {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/print.png) no-repeat center center;
  }
  .accessories-icon_download {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/download.png) no-repeat center center;
  }
  .accessories-icon_mail {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/mail.png) no-repeat center center;
  }
  .accessories-icon_dealer {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/dealer.png) no-repeat center center;
  }
</style>